import { Me } from "../types/profile";
import { get } from "./fetch.core";
import { getLoginToken } from "./login.core";

export async function getProfile() {
  if (!getLoginToken()) return null;

  const res = await get<Me>("/admin/me");
  return res.data;
}
